import { useEffect, useState } from "react";
import { Path, Phone } from "@phosphor-icons/react";
import client from "../lib/api";

const STEPS = [
  { key: "signup", label: "Signed up" },
  { key: "load", label: "First load" },
  { key: "invoice", label: "First invoice" },
  { key: "paid", label: "Invoice paid" },
  { key: "won", label: "Deal won" },
];

export const SignupWinPathCard = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    client.get("/admin/signup-win-path").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || !data.count) return null;

  return (
    <div className="mt-6 card-surface p-4" data-testid="signup-win-path-card">
      <div className="flex items-center gap-2 mb-3">
        <Path size={14} weight="bold" color="#38bdf8" />
        <span className="overline">SIGNUP → WIN PATH · WHAT TO COACH NEXT</span>
      </div>
      <div className="space-y-2">
        {data.rows.map((r) => (
          <div
            key={r.lead_id}
            data-testid={`win-path-row-${r.lead_id}`}
            className="rounded-md border border-white/[0.06] bg-white/[0.02] px-3 py-2.5"
          >
            <div className="flex items-center gap-3 flex-wrap">
              <div className="min-w-0 flex-1">
                <div className="text-xs font-medium text-neutral-200 truncate">
                  {r.company_name || r.contact_name || "A signup"}
                  <span className="text-neutral-500 font-normal"> · {r.days_since_signup}d since signup</span>
                </div>
                <div className="flex items-center gap-1 mt-1.5">
                  {STEPS.map((s, i) => (
                    <div key={s.key} className="flex items-center gap-1" title={s.label}>
                      <div
                        className={`h-2 w-2 rounded-full ${
                          r.milestones[s.key]
                            ? "bg-emerald-400"
                            : r.next_key === s.key
                              ? "bg-[#FF5A1F] animate-pulse"
                              : "bg-white/10"
                        }`}
                      />
                      {i < STEPS.length - 1 && <div className={`h-px w-4 ${r.milestones[s.key] ? "bg-emerald-400/40" : "bg-white/10"}`} />}
                    </div>
                  ))}
                </div>
              </div>
              <div className="text-right">
                <span
                  data-testid={`win-path-next-${r.lead_id}`}
                  className={`rounded-full border px-2.5 py-0.5 text-[10px] font-semibold ${
                    r.next_key
                      ? "border-[#FF5A1F]/40 bg-[#FF5A1F]/10 text-[#FF9764]"
                      : "border-emerald-500/40 bg-emerald-500/10 text-emerald-300"
                  }`}
                >
                  {r.next_key ? `Next: ${r.next_label}` : "Fully activated"}
                </span>
                {r.phone && (
                  <a
                    href={`tel:${r.phone}`}
                    data-testid={`win-path-call-${r.lead_id}`}
                    className="ml-2 inline-flex items-center gap-1 rounded-full border border-white/15 px-2 py-0.5 text-[10px] font-semibold text-neutral-300 hover:border-white/30 transition-colors"
                  >
                    <Phone size={10} weight="bold" /> Call
                  </a>
                )}
              </div>
            </div>
            <div className="text-[10px] text-neutral-500 mt-1.5">{r.coach_tip}</div>
          </div>
        ))}
      </div>
    </div>
  );
};
